import React from "react";
import { formatCash } from "../../utils/operatorConsoleHelpers";

const JoinedBetsFilterNav = ({
  openCount,
  totalStaked,
  totalPotential,
  resultCount,
}) => {
  return (
    <nav className="jb-rail-nav" aria-label="Portfolio summary">
      <header className="jb-rail-nav-head">
        <span className="jb-rail-nav-kicker">Portfolio</span>
        <div className="jb-rail-nav-summary" aria-label="Ticket summary">
          <div className="jb-rail-nav-summary-stat">
            <em>Open</em>
            <strong
              className={`tabular-nums ${openCount > 0 ? "jb-rail-nav-summary-live" : ""}`}
            >
              {openCount}
            </strong>
          </div>
          <div className="jb-rail-nav-summary-stat">
            <em>Staked</em>
            <strong className="tabular-nums">
              {formatCash(totalStaked, { compact: true })}
            </strong>
          </div>
          <div className="jb-rail-nav-summary-stat">
            <em>Up</em>
            <strong className="tabular-nums jb-rail-nav-summary-accent">
              {formatCash(totalPotential, { compact: true })}
            </strong>
          </div>
          <div className="jb-rail-nav-summary-stat">
            <em>Showing</em>
            <strong className="tabular-nums">{resultCount}</strong>
          </div>
        </div>
        <p className="jb-rail-nav-headline">
          {openCount > 0 ? (
            <>
              <span className="jb-rail-nav-pulse" aria-hidden />
              <strong className="tabular-nums">{openCount}</strong> open slip
              {openCount === 1 ? "" : "s"}
            </>
          ) : (
            "No open slips"
          )}
        </p>
      </header>
    </nav>
  );
};

export default JoinedBetsFilterNav;
